import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Shield, Mail, Info } from 'lucide-react';

export default function LegalNotice() {
  return (
    <div className="min-h-screen pt-20 px-4 bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100">
      <div className="max-w-4xl mx-auto space-y-6">
        <Card className="backdrop-blur-sm bg-white/90">
          <CardHeader>
            <div className="flex items-center gap-3 mb-4">
              <Shield className="w-8 h-8 text-[#54075B]" />
              <h1 className="text-3xl font-bold">Mentions Légales</h1>
            </div>
          </CardHeader>
          <CardContent className="space-y-8">
            {/* Éditeur */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold flex items-center gap-2">
                <Info className="w-5 h-5 text-[#54075B]" />
                Éditeur du site
              </h2>
              <div className="space-y-2 text-gray-700">
                <p>
                  <strong>Cabinet Immersion 7</strong><br />
                  77169 Boissy-le-Châtel, France
                </p>
                <p className="flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  <a href="mailto:cabinet.immersion.7@gmail.com" className="text-[#54075B] hover:underline">
                    cabinet.immersion.7@gmail.com
                  </a>
                </p>
              </div>
            </section>

            {/* Directeur de publication */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Directeur de publication</h2>
              <p className="text-gray-700">Christel</p>
            </section>

            {/* Hébergement */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Hébergement</h2>
              <p className="text-gray-700">
                Cette application est hébergée par Netlify Inc.<br />
                44 Montgomery Street, Suite 300<br />
                San Francisco, California 94104<br />
                United States
              </p>
            </section>

            {/* Propriété intellectuelle */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Propriété intellectuelle</h2>
              <p className="text-gray-700">
                Tous les éléments présents sur l'application (textes, images, logos, graphismes, vidéos, etc.) 
                sont protégés par les lois en vigueur sur la propriété intellectuelle et appartiennent au 
                Baromètre Énergétique du "labo HED" ou à ses partenaires. Toute reproduction, distribution, 
                modification, adaptation ou publication, même partielle, de ces éléments est strictement interdite 
                sans l'autorisation écrite préalable du Baromètre Énergétique.
              </p>
            </section>

            {/* Données personnelles */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Protection des données</h2>
              <p className="text-gray-700">
                Le Baromètre Énergétique s'engage à respecter la confidentialité des données personnelles 
                de ses utilisateurs conformément au Règlement Général sur la Protection des Données (RGPD). 
                Les informations collectées sont utilisées uniquement pour assurer le bon fonctionnement 
                de l'application et améliorer les services proposés.
              </p>
            </section>

            {/* Responsabilité */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Responsabilité</h2>
              <p className="text-gray-700">
                Le Baromètre Énergétique du "labo HED" met tout en œuvre pour fournir des informations 
                précises et à jour. Cependant, nous ne saurions être tenus responsables des erreurs, 
                omissions ou interruptions de service. L'utilisation de l'application se fait sous la 
                responsabilité exclusive de l'utilisateur.
              </p>
            </section>

            {/* Conditions d'utilisation */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Conditions d'utilisation</h2>
              <p className="text-gray-700">
                L'accès et l'utilisation de l'application impliquent l'acceptation pleine et entière 
                des présentes mentions légales et des conditions générales d'utilisation. Ces conditions 
                sont susceptibles d'être modifiées à tout moment sans préavis.
              </p>
            </section>

            {/* Contact */}
            <section className="space-y-4">
              <h2 className="text-xl font-semibold">Contact</h2>
              <p className="text-gray-700">
                Pour toute question, réclamation ou demande d'information, veuillez nous contacter à :<br />
                <a href="mailto:cabinet.immersion.7@gmail.com" className="text-[#54075B] hover:underline">
                  cabinet.immersion.7@gmail.com
                </a>
              </p>
            </section>

            {/* Dernière mise à jour */}
            <section className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Dernière mise à jour : Janvier 2025
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}